export default {
  default: {
    // api接口请求
    API_VERSION: 'https://test-api-jc.survey.work',
    API_VERSION_H: 'https://test-front-base.survey.work',
    // 不同项目域名、端口区分，可用于页面跳转
    projects: {
      web: {
        port: '4000',
        domain: 'localhost',
      },
      nest: {
        port: '4004',
        domain: 'localhost',
      },
    },
  },
  dev: {
    API_VERSION: 'https://test-api-jc.survey.work',
    API_VERSION_H: 'https://test-api-jc.survey.work/base',
    projects: {
      web: {
        port: '4000',
        domain: 'localhost',
      },
      nest: {
        port: '4004',
        domain: 'localhost',
      },
    },
  },
  test: {
    API_VERSION: 'https://test-api-jc.survey.work',
    API_VERSION_H: 'https://test-front-base.survey.work',
    projects: {
      web: {
        port: '4000',
        domain: 't2.jianchaba.com',
      },
      nest: {
        port: '4004',
        domain: 't7.survey.work',
      },
    },
  },
  prod: {
    API_VERSION: 'https://api-jc.survey.work',
    API_VERSION_H: 'https://survey.work/api',
    projects: {
      web: {
        port: '8002',
        domain: '39.107.89.56:8002',
      },
      nest: {
        port: '8013',
        domain: '39.107.89.56:8013',
      },
    },
  },
}
